<script lang="ts">
	import { t } from '../../i18n/i18n'
	import Basic from '../templates/Basic.svelte'

	interface Props {
		code?: number | string
		description?: string
	}

	/**
	 * the error surface for the app's own pages.
	 *
	 * PubPage40x cannot do this job: it wraps the message in a whole fake offer
	 * page built from DefaultLot() — salutation, InfoCard, project grid, two
	 * textareas, a FileUpload and a "save remark" button. that is right for an
	 * expired magic link and nonsense on /manage/tags, where the visitor is a
	 * logged-in user who lacks a permission.
	 *
	 * deliberately a paragraph. the backend already writes a usable sentence
	 * ("Sie benötigen die Berechtigung 'permission-customize-pubpages'"), so the
	 * job here is to show it rather than to invent wording for every code.
	 *
	 * wrapped in `Basic` for the menu bar and footer, like the pub error pages on
	 * the sibling branches of the same `{#if}`. bare, it left a logged-in user
	 * on a floating paragraph with no way out but the URL bar.
	 */
	let { code, description }: Props = $props()
</script>

<!-- nothing is loading on an error page; Basic's animation defaults to on and
     buried the message under its blur overlay -->
<Basic showLoadingAnimation={false}>
	<section class="route-error" role="alert">
		{#if code}
			<p class="route-error__code">{code}</p>
		{/if}
		<!-- postAndDownload builds its message as errorMessage || statusText, and statusText
		     is empty on HTTP/2 — an empty description must not render a blank error page -->
		<p class="route-error__message">{description || $t('Lot.notification.unknown.error')}</p>
	</section>
</Basic>

<style lang="scss">
	.route-error {
		display: flex;
		flex-direction: column;
		gap: 0.5rem;
		padding: 3rem 1.5rem;
		max-width: 40rem;
		margin: 0 auto;

		&__code {
			margin: 0;
			font-size: 0.875rem;
			font-weight: 600;
			letter-spacing: 0.08em;
			opacity: 0.6;
		}

		&__message {
			margin: 0;
			font-size: 1.125rem;
			line-height: 1.5;
		}
	}
</style>
